import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Buenos Aires',
  text: 'Antes terminaba pidiendo delivery porque no sabía qué hacer. Ahora tenemos el menú de la semana listo el domingo en 10 minutos. Comemos mejor y gastamos menos.'
}, {
  name: 'Roberto P.',
  location: 'Rosario',
  text: 'Las empanadas y pizzas del Tomo 4 son un éxito total. Mis hijos ahora piden cocinar juntos. Nunca me había pasado eso.'
}, {
  name: 'Julieta M.',
  location: 'Mendoza',
  text: 'Como mamá que trabaja todo el día, llegar a casa era un caos. Con el Tomo 2 de Minutas Rápidas, en 20 minutos estamos comiendo algo rico y sano. Me cambió la vida.'
}, {
  name: 'Martín S.',
  location: 'La Plata',
  text: 'Nunca fui de cocinar, pero las instrucciones son tan claras que hasta yo me luzco. El planificador semanal nos ahorró muchísima plata en el súper. ¡Recomendadísimo!'
}, {
  name: 'Laura C.',
  location: 'Córdoba',
  text: 'El Bono de Comidas Salvavidas me rescató tres veces esta semana. Y la chocotorta de Postres Resueltos fue la estrella del fin de semana.'
}];
export const TestimonialsSection = () => {
  return <section className="py-16 px-4 bg-gray-900 border-y border-orange-900/50" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-250">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-251">
            ⭐ LO QUE DICEN LAS FAMILIAS
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-252"></div>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-253">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black p-6 rounded-2xl border border-orange-500/20 shadow-[0_0_15px_rgba(249,115,22,0.05)] ${i === 4 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-254">
              <div className="flex gap-1 mb-4" data-id="element-255">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-orange-500 text-orange-500" data-id="element-256" />)}
              </div>
              <p className="text-gray-300 text-lg italic mb-6 leading-relaxed" data-id="element-257">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 border-t border-gray-800 pt-4" data-id="element-258">
                <div className="w-10 h-10 rounded-full bg-orange-900 flex items-center justify-center text-orange-400 font-bold text-xl" data-id="element-259">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-260">
                  <p className="text-white font-bold" data-id="element-261">{t.name}</p>
                  <p className="text-orange-500 text-sm" data-id="element-262">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};